import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

const AGB = () => (
  <div className="min-h-screen bg-background">
    <div className="container max-w-2xl py-8">
      <Link to="/">
        <Button variant="ghost" size="sm" className="mb-6 gap-2">
          <ArrowLeft className="h-4 w-4" /> Zurück
        </Button>
      </Link>

      <h1 className="text-2xl font-bold text-foreground mb-2">Allgemeine Geschäftsbedingungen (AGB)</h1>
      <p className="text-sm text-muted-foreground mb-8">Stand: März 2026</p>

      <div className="space-y-8 text-sm leading-relaxed text-muted-foreground">
        <section>
          <h2 className="text-base font-semibold text-foreground mb-2">§ 1 Geltungsbereich</h2>
          <p>(1) Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB") gelten für die Nutzung der Plattform chargeflip (nachfolgend „Plattform"), betrieben von Collabobit, Julia Weichner, Thomas-Jefferson-Str. 53, 68309 Mannheim (nachfolgend „Betreiber").</p>
          <p className="mt-2">(2) Die Plattform vermittelt die zeitweise Vermietung des Zugangs zu privaten Ladeinfrastrukturen (Wallboxen) zwischen Anbietern (nachfolgend „Hosts") und Nutzern (nachfolgend „Fahrer"). Der Betreiber ist kein Energieversorger und verkauft keinen Strom.</p>
          <p className="mt-2">(3) Abweichende AGB des Nutzers werden nicht anerkannt, es sei denn, der Betreiber stimmt ihrer Geltung ausdrücklich schriftlich zu.</p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground mb-2">§ 2 Vertragsgegenstand</h2>
          <p>(1) Der Betreiber stellt eine Online-Plattform zur Verfügung, über die Hosts den zeitlich begrenzten Zugang zu ihrer privaten Ladeinfrastruktur anbieten können und Fahrer diesen Zugang buchen können.</p>
          <p className="mt-2">(2) Der Vertrag über die Vermietung des Ladezugangs kommt ausschließlich zwischen Host und Fahrer zustande. Der Betreiber ist lediglich Vermittler und nicht Vertragspartei des Mietvertrages.</p>
          <p className="mt-2">(3) Die Abrechnung erfolgt zeitbasiert (€/Stunde). Es findet kein Stromverkauf im Sinne des Energiewirtschaftsgesetzes (EnWG) statt.</p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground mb-2">§ 3 Registrierung und Nutzerkonto</h2>
          <p>(1) Die Nutzung der Plattform setzt eine Registrierung voraus. Nutzer müssen wahrheitsgemäße und vollständige Angaben machen.</p>
          <p className="mt-2">(2) Jeder Nutzer darf nur ein Konto führen. Das Konto ist nicht übertragbar.</p>
          <p className="mt-2">(3) Der Nutzer ist verpflichtet, seine Zugangsdaten vertraulich zu behandeln und den Betreiber unverzüglich über einen Missbrauch seines Kontos zu informieren.</p>
          <p className="mt-2">(4) Der Betreiber behält sich vor, Nutzerkonten bei Verstoß gegen diese AGB zu sperren oder zu löschen.</p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground mb-2">§ 4 Pflichten der Hosts</h2>
          <p>(1) Der Host gewährleistet, dass seine Wallbox in einem technisch einwandfreien und sicheren Zustand ist.</p>
          <p className="mt-2">(2) Der Host stellt sicher, dass er berechtigt ist, den Ladezugang an seinem Standort anzubieten (z. B. bei Mietwohnungen: Zustimmung des Vermieters).</p>
          <p className="mt-2">(3) Der Host ist verantwortlich für die Richtigkeit seiner Angaben zu Standort, Steckertyp, Leistung und Verfügbarkeit.</p>
          <p className="mt-2">(4) Der Host vermietet den Zugang zu seiner Ladeinfrastruktur gemäß §21 EStG (Einkünfte aus Vermietung und Verpachtung). Die steuerliche Verantwortung liegt beim Host.</p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground mb-2">§ 5 Pflichten der Fahrer</h2>
          <p>(1) Der Fahrer verpflichtet sich, die Ladeinfrastruktur des Hosts pfleglich zu behandeln und nach Nutzung ordnungsgemäß zu hinterlassen.</p>
          <p className="mt-2">(2) Der Fahrer stellt sicher, dass sein Fahrzeug mit dem angebotenen Steckertyp kompatibel ist.</p>
          <p className="mt-2">(3) Der Fahrer ist verpflichtet, den gebuchten Zeitraum einzuhalten und den Ladeplatz pünktlich freizugeben.</p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground mb-2">§ 6 Preise und Zahlung</h2>
          <p>(1) Die Preise werden vom Host festgelegt und als Brutto-Preis pro Stunde auf der Plattform angezeigt.</p>
          <p className="mt-2">(2) Die Zahlung erfolgt über den integrierten Zahlungsdienstleister Stripe. Mit der Buchung autorisiert der Fahrer die Abbuchung.</p>
          <p className="mt-2">(3) Der Betreiber erhebt eine Vermittlungsgebühr in Höhe von 20 % des Buchungsbetrags. Die verbleibenden 80 % werden an den Host ausgezahlt.</p>
          <p className="mt-2">(4) Rechnungen und Abrechnungsübersichten werden über das Nutzerkonto bereitgestellt.</p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground mb-2">§ 7 Stornierung und Rücktritt</h2>
          <p>(1) Eine kostenlose Stornierung ist bis zu 24 Stunden vor dem gebuchten Zeitraum möglich.</p>
          <p className="mt-2">(2) Bei späterer Stornierung oder Nichterscheinen kann der volle Buchungsbetrag einbehalten werden.</p>
          <p className="mt-2">(3) Der Host kann eine Buchung nur aus triftigem Grund absagen. Bei wiederholten Absagen behält sich der Betreiber vor, den Ladepunkt zu deaktivieren.</p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground mb-2">§ 8 Haftung</h2>
          <p>(1) Der Betreiber haftet nur für Schäden, die auf einer vorsätzlichen oder grob fahrlässigen Pflichtverletzung beruhen.</p>
          <p className="mt-2">(2) Die Haftung für leichte Fahrlässigkeit ist auf die Verletzung wesentlicher Vertragspflichten (Kardinalpflichten) beschränkt und auf den vorhersehbaren, vertragstypischen Schaden begrenzt.</p>
          <p className="mt-2">(3) Der Betreiber haftet nicht für Schäden, die durch die Nutzung der Wallbox des Hosts entstehen, es sei denn, der Betreiber hat den Schaden durch eigene Pflichtverletzung verursacht.</p>
          <p className="mt-2">(4) Die Haftung für Schäden an Leben, Körper und Gesundheit bleibt unberührt.</p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground mb-2">§ 9 Datenschutz</h2>
          <p>Die Erhebung und Verarbeitung personenbezogener Daten erfolgt gemäß unserer <Link to="/datenschutz" className="text-primary underline">Datenschutzerklärung</Link> und den geltenden datenschutzrechtlichen Bestimmungen (DSGVO, BDSG).</p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground mb-2">§ 10 Streitbeilegung</h2>
          <p>(1) Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-primary underline">https://ec.europa.eu/consumers/odr</a>.</p>
          <p className="mt-2">(2) Der Betreiber ist weder bereit noch verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground mb-2">§ 11 Änderungen der AGB</h2>
          <p>(1) Der Betreiber behält sich vor, diese AGB mit Wirkung für die Zukunft zu ändern. Über Änderungen wird der Nutzer per E-Mail oder über die Plattform informiert.</p>
          <p className="mt-2">(2) Widerspricht der Nutzer nicht innerhalb von vier Wochen nach Zugang der Änderungsmitteilung, gelten die geänderten AGB als akzeptiert.</p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground mb-2">§ 12 Schlussbestimmungen</h2>
          <p>(1) Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.</p>
          <p className="mt-2">(2) Gerichtsstand für alle Streitigkeiten aus oder im Zusammenhang mit diesen AGB ist, soweit gesetzlich zulässig, Mannheim.</p>
          <p className="mt-2">(3) Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.</p>
        </section>
      </div>
    </div>
  </div>
);

export default AGB;
